import _objectWithoutProperties from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  animation: ", " 500ms;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import { MdCheck, MdErrorOutline } from 'react-icons/md';
import styled from "../../../styled";
import { shake } from "../../../animations";
import { BusyButton } from "../..";
export var DEFAULT_SUBMIT_LABEL = 'Save';
var StyledErrorIcon = styled(MdErrorOutline)(_templateObject(), shake);
var IconWrapper = styled.span(function (_ref) {
  var theme = _ref.theme;
  return "\n  color: ".concat(theme.colors.secondaryText, ";\n  & > svg {\n    color: currentColor;\n    vertical-align: baseline;\n  }\n");
});
export var SubmitFeedbackIcon = function SubmitFeedbackIcon(_ref2) {
  var error = _ref2.error;
  return React.createElement(IconWrapper, null, error ? React.createElement(StyledErrorIcon, {
    height: 12
  }) : React.createElement(MdCheck, {
    height: 12
  }));
};
export var SubmitButton = function SubmitButton(_ref3) {
  var id = _ref3.id,
      isBusy = _ref3.isBusy,
      recentlySaved = _ref3.recentlySaved,
      isValid = _ref3.isValid,
      children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["id", "isBusy", "recentlySaved", "isValid", "children"]);

  var label = children || DEFAULT_SUBMIT_LABEL;
  var hasErrors = !isValid && recentlySaved;
  return React.createElement(BusyButton, Object.assign({
    id: id ? "".concat(id, "-submit-btn") : undefined,
    isBusy: isBusy,
    type: "submit",
    palette: hasErrors ? 'danger' : 'secondary'
  }, props), recentlySaved ? React.createElement(SubmitFeedbackIcon, {
    error: hasErrors
  }) : label);
};